import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import {useTheme} from '@material-ui/core/styles';

const PhoneIcon = ({primary, ...props}) => {
  const theme = useTheme();
  const fill = primary
    ? theme.palette.primary.main
    : theme.palette.common.white;

  return (
    <SvgIcon
      {...props}
      width="29.635"
      height="29.635"
      viewBox="0 0 29.635 29.635"
    >
      <g transform="translate(0 0)">
        <path
          fill={fill}
          d="M27.257,19.452a16.826,16.826,0,0,1-5.284-.842,2.326,2.326,0,0,0-2.349.5l-3.332,2.515a18.415,18.415,0,0,1-8.279-8.278L10.454,10.1a2.4,2.4,0,0,0,.589-2.427A16.851,16.851,0,0,1,10.2,2.378,2.381,2.381,0,0,0,7.82,0H2.378A2.381,2.381,0,0,0,0,2.378,27.288,27.288,0,0,0,27.257,29.635a2.381,2.381,0,0,0,2.378-2.378V21.83A2.381,2.381,0,0,0,27.257,19.452Zm.732,7.805a.732.732,0,0,1-.732.732A25.639,25.639,0,0,1,1.646,2.378a.732.732,0,0,1,.732-.732H7.82a.732.732,0,0,1,.732.732,18.461,18.461,0,0,0,.924,5.8.819.819,0,0,1-.26.844l-2.83,3.748a.824.824,0,0,0-.077.869A20.436,20.436,0,0,0,16,23.324a.82.82,0,0,0,.871-.076l3.834-2.9a.727.727,0,0,1,.746-.174,18.486,18.486,0,0,0,5.809.928.732.732,0,0,1,.732.732Z"
          transform="translate(0 0)"
        />
      </g>
    </SvgIcon>
  );
};

export default PhoneIcon;
